import React from 'react'
import styled from 'styled-components'
function NotCollegeAllot() {
    return (
        <Next>
            <center><p style={{ textDecoration: 'none',p:"2", fontSize: '1.2rem', marginTop: '9rem', fontWeight: 'bold' }}>
            Based on your preference and choices of program you have not been allotted a seat in Round 3 of Counseling . However Previously You have been allotted a seat in either of Round 1 or Round 2 which was not confirmed by you.
            </p></center>
            {/* <center><p style={{ fontSize: '1rem', marginTop: '1rem', fontWeight: 'bold' }}>
            Thank you for participating in the counseling rounds of AICEE 2023. <br></br>
You can claim your refund of INR 2300/- from 20th May, 2023 ( A separate link will be provided for that).
            </p></center> */}
            <center><button className='counsellingButton'
                // onClick={() => { alert('College Choice Filling Round 3 will begin from 25th July, 2025, 12:00 PM') }}
                 onClick={() => { navigate('https://aicee.in/refund-login') }}
              // onClick={() => { setCounsellingPortal(true) }}

            ><a target="__blank" href="https://aicee.in/refund-login" className='text-white' style={{textDecoration:"none"}}>AICEE 2026 Counseling Refunds ( Click here)</a></button></center>
        </Next>
    )
}

const Next = styled.main`
.counsellingButton{
  margin: 1rem;
  padding: 0.5rem 2rem;
  color: white;
  background-color: #042e2e;
}
`

export default NotCollegeAllot
